var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBing = function SvgBing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 6,
    y: 5,
    fill: "#fff",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M22.204 17.936q-.004.038-.003.078 0 .157.058.296l.033.07.132.338.684 1.757.596 1.533c.17.31.442.553.771.682l.102.038.016.003 1.634.566v.001l.625.216.043.015.006.001q.185.047.359.125a2.4 2.4 0 0 1 .944.74q.09.116.165.243a2.43 2.43 0 0 1 .32 1.593v.003l-.02.109-.021.105-.004.012a2 2 0 0 1-.096.31 2.183 2.183 0 0 1-.199.4q-.114.186-.26.349a5.4 5.4 0 0 0 1.436-3.68q0-.189-.013-.378a5.4 5.4 0 0 0-1.722-3.603 5.3 5.3 0 0 0-.885-.667l-.6-.31-3.046-1.573a.765.765 0 0 0-1.055.628"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bing_svg__a)",
    d: "M22.204 17.936q-.004.038-.003.078 0 .157.058.296l.033.07.132.338.684 1.757.596 1.533c.17.31.442.553.771.682l.102.038.016.003 1.634.566v.001l.625.216.043.015.006.001q.185.047.359.125a2.4 2.4 0 0 1 .944.74q.09.116.165.243a2.43 2.43 0 0 1 .32 1.593v.003l-.02.109-.021.105-.004.012a2 2 0 0 1-.096.31 2.183 2.183 0 0 1-.199.4q-.114.186-.26.349a5.4 5.4 0 0 0 1.436-3.68q0-.189-.013-.378a5.4 5.4 0 0 0-1.722-3.603 5.3 5.3 0 0 0-.885-.667l-.6-.31-3.046-1.573a.765.765 0 0 0-1.055.628"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M16.781 11a.8.8 0 0 0-.781.801v13.98q.003.146.014.292.009.078.023.157a2.38 2.38 0 0 0 2.338 1.973 2.36 2.36 0 0 0 1.139-.291l.121-.074.491-.291.625-.374.002-12.42a2.4 2.4 0 0 0-1.081-2.016l-2.431-1.6A.8.8 0 0 0 16.81 11z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bing_svg__b)",
    d: "M16.781 11a.8.8 0 0 0-.781.801v13.98q.003.146.014.292.009.078.023.157a2.38 2.38 0 0 0 2.338 1.973 2.36 2.36 0 0 0 1.139-.291l.121-.074.491-.291.625-.374.002-12.42a2.4 2.4 0 0 0-1.081-2.016l-2.431-1.6A.8.8 0 0 0 16.81 11z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "m26.422 23.772-5.59 3.336-.08.049v.017l-.625.373-.491.292-.12.073-.01.004a2.35 2.35 0 0 1-1.13.288 2.38 2.38 0 0 1-2.339-1.974c.094.822.372 1.586.79 2.252a5.37 5.37 0 0 0 4.012 2.492h1.033c.913-.096 1.676-.464 2.478-.962l1.232-.759c.556-.358 2.063-1.24 2.507-1.734a2.44 2.44 0 0 0 .622-1.631 2.44 2.44 0 0 0-1.452-2.233 2 2 0 0 0-.359-.125l-.005-.001-.043-.015z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bing_svg__c)",
    d: "m26.422 23.772-5.59 3.336-.08.049v.017l-.625.373-.491.292-.12.073-.01.004a2.35 2.35 0 0 1-1.13.288 2.38 2.38 0 0 1-2.339-1.974c.094.822.372 1.586.79 2.252a5.37 5.37 0 0 0 4.012 2.492h1.033c.913-.096 1.676-.464 2.478-.962l1.232-.759c.556-.358 2.063-1.24 2.507-1.734a2.44 2.44 0 0 0 .622-1.631 2.44 2.44 0 0 0-1.452-2.233 2 2 0 0 0-.359-.125l-.005-.001-.043-.015z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M28.711 25.888a2.5 2.5 0 0 1-.126.778 4 4 0 0 1-.08.208 2.408 2.408 0 0 1-.416.644c-.444.495-1.951 1.377-2.506 1.735l-1.233.76c-.904.56-1.758.957-2.835.984a5 5 0 0 1-.357-.001 5.36 5.36 0 0 1-4.33-2.514 5.36 5.36 0 0 1-.79-2.252 2.38 2.38 0 0 0 2.337 1.974c.41 0 .796-.105 1.132-.288l.008-.004.12-.073.491-.292.625-.373v-.017l.08-.05 5.59-3.336.431-.257.043.015.005.001q.186.047.36.125a2.4 2.4 0 0 1 .944.74q.09.116.165.243c.217.364.342.793.342 1.25",
    opacity: 0.15
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bing_svg__d)",
    d: "M28.711 25.888a2.5 2.5 0 0 1-.126.778 4 4 0 0 1-.08.208 2.408 2.408 0 0 1-.416.644c-.444.495-1.951 1.377-2.506 1.735l-1.233.76c-.904.56-1.758.957-2.835.984a5 5 0 0 1-.357-.001 5.36 5.36 0 0 1-4.33-2.514 5.36 5.36 0 0 1-.79-2.252 2.38 2.38 0 0 0 2.337 1.974c.41 0 .796-.105 1.132-.288l.008-.004.12-.073.491-.292.625-.373v-.017l.08-.05 5.59-3.336.431-.257.043.015.005.001q.186.047.36.125a2.4 2.4 0 0 1 .944.74q.09.116.165.243c.217.364.342.793.342 1.25",
    opacity: 0.15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bing_svg__a",
    x1: 23.108,
    x2: 29.506,
    y1: 18.104,
    y2: 25.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#26C6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#15D0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3BD6DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62DCD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bing_svg__b",
    x1: 18.702,
    x2: 18.495,
    y1: 27.901,
    y2: 12.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B48EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2080F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26B8F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bing_svg__c",
    x1: 22.374,
    x2: 37.741,
    y1: 27.244,
    y2: 27.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#248FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104CF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bing_svg__d",
    x1: 22.374,
    x2: 37.741,
    y1: 27.244,
    y2: 27.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
};
export default SvgBing;